const getUnreadChatsCountTitle = (chats: { unreadMessageCount?: number }[] = []) => {
  let count = 0;
  for (let i = 0; i < chats?.length; i += 1) {
    count += Math.min(chats[i]?.unreadMessageCount || 0, 1);
  }
  return `${count > 0 ? `(${count > 32 ? '32+' : count}) ` : ''}Marley Chat`;
};

export default getUnreadChatsCountTitle;
